<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="primary"
      dark
      flat
      fixed-tabs
      next-icon="mdi-chevron-right"
      prev-icon="mdi-chevron-left"
      show-arrows
    >
      <v-tab
        v-for="item in tabs"
        :key="item.value"
        :href="item.value"
        @click="$inertia.visit(item.href, { preserveState: true })"
      >
        {{ item.title }}
      </v-tab>
    </v-tabs>

    <v-container fluid>
      <portal-target name="flash" />
      <slot />
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    team: {
      type: Object,
      required: false,
      default: null
    },
    permissions: {
      type: Object,
      required: false,
      default: null
    },
    activeTab: {
      type: String,
      required: false,
      default: null
    }
  },

  data() {
    return {
      tab: this.activeTab,
    }
  },

  computed: {
    tabs() {
      return [
        {
          title: this.$t('Current team'),
          value: '#show',
          href: this.route('team.show', this.$page.props.user.current_team.id)
        },
        {
          title: this.$t('Create new team'),
          value: '#create',
          href: this.route('team.create')
        },
      ]
    }
  },

  watch: {
    activeTab: function(value) {
      this.tab = value;
    }
  }
}
</script>
